import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";

// UI
import { ContainerNew, SubMenu, RightMenu } from "../Layout";

import { RightMenuLayer } from "./RightMenuLayer";
import LocationTerms from "./TermsDetail/LocationTerms";
import PrivateTerms from "./TermsDetail/PrivateTerms";
import ServiceTerms from "./TermsDetail/ServiceTerms";

export default (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);

    useEffect(() => {
        userHabit(phonecfg, 'TP100');
        NativeAction(phonecfg, "statusColor", "#A5AEE4");
    }, [phonecfg.version]);

    return (
        <Fragment>

            <ContainerNew Title={ '약관보기' } 
                dark={'dark'} 
                leftMenu={SubMenu} goToUrl={'/mp'} 
                rightMenu={RightMenu}
            >

                <div className="contents">
                    <div className="sub-contents">

                        <div className="device-link-contain type4">
                            <div>
                                <div className="round-list">
                                    <div className="title">
                                        서비스 이용약관
                                    </div>
                                </div>
                            </div>

                            <ServiceTerms />

                            <PrivateTerms />

                            <LocationTerms />
                        </div>

                    </div>
                </div>
            </ContainerNew>

            <RightMenuLayer />

        </Fragment>
    );
};